import dateHelper from 'helpers/dateHelper';
import { startCase } from 'lodash';


export const SUMMARY_TAB = 'summary';
export const TRAVEL_TAB = 'travel';
export const ECONOMIC_TAB = 'economic';
export const HEALTH_TAB = 'health';

export default {
  mapTravelDetails,
  mapCovidData
};

function mapTravelDetails(data: any) {
  let travelDetails: any = {};

  let trips = data?.trips;
  if (!trips) return travelDetails;

  let tripDetails = trips[trips.length-1];
  if (!tripDetails || !tripDetails.data) return travelDetails;

  let tripData = tripDetails.data;

  travelDetails[TRAVEL_TAB] = getTravelDetailsForCategory(tripData['containment_and_closure']);
  travelDetails[ECONOMIC_TAB] = getTravelDetailsForCategory(tripData['economic']);
  travelDetails[HEALTH_TAB] = getTravelDetailsForCategory(tripData['health_systems']);
  travelDetails[SUMMARY_TAB] = getSummaryDetails(data, tripDetails);

  return travelDetails;
}

function mapCovidData(data: any) {
  let stats: any = [];

  data.forEach(item => {
    let statItem = {
      id: item.id,
      date: dateHelper.getGraphDateObject(item.date),
      value: item.new_cases
    };

    stats.push(statItem);
  });

  return stats.reverse();
}

//helper methods

function getTravelDetailsForCategory(obj) {
  let result: any = [];

  if (!obj) return result;

  for (let key of Object.keys(obj)) {
    let objData = obj[key];

    let notes = objData?.notes;
    if (!notes) continue;

    let noteDetails = notes[0];
    if (!noteDetails) continue;

    let item = {
      id: key,
      title: startCase(key.replace('_', ' ')),
      date: dateHelper.displayDate(noteDetails.date),
      latestNote: noteDetails.note
    };

    result.push(item);
  }

  return result;
}

function getSummaryDetails(searchResult, tripDetails) {
  const advice = tripDetails.advice;

  let result = {
    advice: {
      riskLevel: searchResult.risk_level,
      riskLevelRecomandation: searchResult.recommendation,
      requirements: searchResult.requirements
    },
    from: tripDetails.from,
    to: tripDetails.to,
    date: dateHelper.displayDate(tripDetails.start_date),
    recommendation: advice.recommendation,
    description: advice.level_desc,
    countryCode: advice.country_code,
    latitude: advice.lat,
    longitude: advice.lon
  };

  return result;
}
